import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class NewsBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.News;
  get Icon(): React.ComponentType<SvgIconProps> {
    return TextSnippetIcon;
  }
}
